import { animate, group, query, style, transition, trigger } from '@angular/animations';

export const fadeInAnimation = trigger('fadeAnimation', [transition('* <=> *', [style({ opacity: 0 }), animate('300ms ease-in-out', style({ opacity: 1 }))])]);

export const slideInAnimation = trigger('slideInAnimation', [
    // Claim Detail - Slide in from left to right
    transition('* => ClaimDetail', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    width: '100%',
                }),
            ],
            { optional: true },
        ),
        group([
            query(':leave', [animate('300ms ease-in-out', style({ transform: 'translateX(100%)', opacity: 0 }))], { optional: true }),
            query(':enter', [style({ transform: 'translateX(-100%)' }), animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))], { optional: true }),
        ]),
    ]),
    // Slide in from right to left
    transition('ClaimDetail => ClaimParent', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    width: '100%',
                }),
            ],
            { optional: true },
        ),
        group([
            query(':leave', [animate('300ms ease-in-out', style({ transform: 'translateX(-100%)', opacity: 0 }))], { optional: true }),
            query(':enter', [style({ transform: 'translateX(100%)' }), animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))], { optional: true }),
        ]),
    ]),
    // Slide in from right to left
    transition('ClaimParent => ClaimDocument', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    width: '100%',
                }),
            ],
            { optional: true },
        ),
        group([
            query(':leave', [animate('300ms ease-in-out', style({ transform: 'translateX(-100%)', opacity: 0 }))], { optional: true }),
            query(':enter', [style({ transform: 'translateX(100%)' }), animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))], { optional: true }),
        ]),
    ]),
    // Slide in from left to right
    transition('ClaimDocument => ClaimParent', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    width: '100%',
                }),
            ],
            { optional: true },
        ),
        group([
            query(':leave', [animate('300ms ease-in-out', style({ transform: 'translateX(100%)', opacity: 0 }))], { optional: true }),
            query(':enter', [style({ transform: 'translateX(-100%)' }), animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))], { optional: true }),
        ]),
    ]),

    transition('ClaimParent => ClaimSubmit', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    width: '100%',
                }),
            ],
            { optional: true },
        ),
        group([
            query(':leave', [animate('300ms ease-in-out', style({ transform: 'translateX(-100%)', opacity: 0 }))], { optional: true }),
            query(':enter', [style({ transform: 'translateX(100%)' }), animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))], { optional: true }),
        ]),
    ]),
    // Slide in from left to right
    transition('ClaimSubmit => ClaimParent', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    width: '100%',
                }),
            ],
            { optional: true },
        ),
        group([
            query(':leave', [animate('300ms ease-in-out', style({ transform: 'translateX(100%)', opacity: 0 }))], { optional: true }),
            query(':enter', [style({ transform: 'translateX(-100%)' }), animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))], { optional: true }),
        ]),
    ]),
]);
